import { useAppDispatch, useAppSelector } from "stores";
import { initUserSessionAction } from "stores/Auth";
import { loadAccessToken } from "utils";

const useAuth = () => {
  const dispatch = useAppDispatch();
  const {
    userProfileFetching,
    userProfileInitializing,
    status,
    userProfile,
    currentOrganization,
  } = useAppSelector((state) => state.auth);

  const initUserSession = () => {
    const accessToken = loadAccessToken();
    if (!accessToken) return;
    dispatch(initUserSessionAction());
  };

  const isLoggedIn = status === "AUTH";

  return {
    isLoggedIn,
    isInitializing: userProfileInitializing,
    isFetching: userProfileFetching,
    data: userProfile,
    initUserSession,
    currentOrganization,
  };
};

export default useAuth;
